import { useMemo } from 'react';
import isEqual from 'lodash/isEqual';
import { slice as historySlice } from 'state/journey-routes/journey-routes-slice';

import { initialState } from 'state/allSlices';
import { store } from 'state/store';

export const useInitialState = () => {
  const currentState = store.getState();

  const excludeSlices = (excludeSlices) => {
    const currentStateCopy = { ...currentState };
    const initialStateCopy = { ...initialState };

    excludeSlices.forEach((sliceName) => {
      delete currentStateCopy[sliceName];
      delete initialStateCopy[sliceName];
    });

    return [currentStateCopy, initialStateCopy];
  };

  const hasStateInitialValue = isEqual(
    ...excludeSlices([
      // delete history slice before compare as this always contains initial landing path
      historySlice.name
    ])
  );

  return useMemo(() => ({ hasStateInitialValue }), [hasStateInitialValue]);
};
